import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAppKitAccount, useAppKit } from '@reown/appkit/react';
import { ethers } from 'ethers';

const WalletContext = createContext();

export const useWallet = () => {
  return useContext(WalletContext);
};

export const WalletProvider = ({ children }) => {
  const { address: rawAddress, isConnected } = useAppKitAccount();
  const { open } = useAppKit();
  const [checksummedAddress, setChecksummedAddress] = useState(null);

  useEffect(() => {
    if (rawAddress && isConnected) {
      try {
        const checkedAddress = ethers.getAddress(rawAddress);
        setChecksummedAddress(checkedAddress);
        console.log('Checksummed Address (Context):', checkedAddress);
      } catch (error) {
        console.error('Error checksumming address in context:', error);
        setChecksummedAddress(rawAddress);
      }
    } else {
      setChecksummedAddress(null);
    }
  }, [rawAddress, isConnected]);

  const connectWallet = async () => {
    try {
      await open();
    } catch (error) {
      console.error('Failed to open wallet modal:', error);
    }
  };

  const value = {
    walletAddress: checksummedAddress,
    isConnected,
    connectWallet,
  };

  return (
    <WalletContext.Provider value={value}>
      {children}
    </WalletContext.Provider>
  );
};
